import { inject as I, getCurrentInstance as v, watch as m, onBeforeUnmount as p } from "vue";
function j(r, o, u) {
  var f;
  const d = I(r, null);
  if (d === null)
    return;
  const a = (f = v()) === null || f === void 0 ? void 0 : f.proxy;
  m(u, e), e(u.value), p(() => {
    e(void 0, u.value);
  });
  function e(n, i) {
    if (!d)
      return;
    const t = d[o];
    i !== void 0 && s(t, i), n !== void 0 && c(t, n);
  }
  function s(n, i) {
    n[i] || (n[i] = []), n[i].splice(n[i].findIndex((t) => t === a), 1);
  }
  function c(n, i) {
    n[i] || (n[i] = []), ~n[i].findIndex((t) => t === a) || n[i].push(a);
  }
}
export {
  j as useInjectionInstanceCollection
};
